
      <!--  FOOTER  -->

      <div *ngIf="links" class="footer">

          <ul>

              <!--  LINK LOOP  -->

              <li *ngFor="let link of links">

                  <!--  ANCHOR LINK  -->

                  <a *ngIf="link.type === 'anchorLink'" [attr.href]="link.href" [attr.target]="link.target">{{ link.text }}</a>

                  <!--  END ANCHOR LINK  -->

                  <!--  LINK BUTTON  -->

                  <a *ngIf="link.type === 'linkButton'" (click)="onLinkButtonClick(link)">{{ link.text }}</a>

                  <!--  END LINK BUTTON -->

                  <!--  ROUTER LINK -->

                  <a *ngIf="link.type === 'routerLink'" [routerLink]="link.navigateTo" [routerLinkActive]="'active'">{{ link.text }}</a>

                  <!--  END ROUTER LINK -->

              </li>

              <!--  END LINK LOOP  -->

          </ul>

      </div>

      <!--  END FOOTER  -->
    